import { Grid } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { GetCustomerCartQuery } from '../../../graphql/magento'
import { CartState, CartStateReduceAction } from '../../../lib/cart/reducers/cart-state'
import CartPromoCode from '../../cart/CartPromoCode'
import CartSummary from '../../cart/CartSummary'
import StyledCartSummaryRow from '../../cart/CartSummaryRow'
import CartSummaryToggle from '../../cart/CartSummaryToggle'

export interface CartFooterProps
  extends Pick<CartState, 'codesCollapsed' | 'formDisabled' | 'summaryVisible'> {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  children?: React.ReactNode
  className?: string
  dispatch: React.Dispatch<CartStateReduceAction>
}

const CartFooter = React.forwardRef<HTMLElement, CartFooterProps>(
  ({ cart, children, className, codesCollapsed, dispatch, formDisabled, summaryVisible }, ref) => (
    <Grid
      className={className}
      component="footer"
      container
      item
      xs={12}
      alignItems="center"
      justify="center"
      innerRef={ref}
    >
      <CartPromoCode
        cart={cart}
        codesCollapsed={codesCollapsed}
        dispatch={dispatch}
        formDisabled={formDisabled}
      />
      <CartSummary cart={cart} summaryVisible={summaryVisible} />
      <CartSummaryToggle cart={cart} dispatch={dispatch} summaryVisible={summaryVisible} />
      {children}
    </Grid>
  ),
)

CartFooter.displayName = 'CartFooter'

const StyledCartFooter = styled(CartFooter)`
  && {
    background-color: ${({ theme }) => theme.colors.coolGray.cool150};
    border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
    bottom: 0;
    left: 0;
    overflow: hidden;
    // use bottom margin on checkout help text instead of padding so text element
    // margins can collapse
    padding: 20px 0 0;
    position: fixed;
    width: 100%;
  }

  & > ${StyledCartSummaryRow} {
    width: 100%;
    padding: 0 15px;
  }

  ${CartSummary}, ${CartSummaryToggle} {
    padding-left: 15px;
    padding-right: 15px;
    flex: 0 0 100%;
  }

  @media (min-width: 600px) {
    && {
      background-color: transparent;
      border: 1px solid transparent;
      border-top: none;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      position: static;
    }

    ${CartSummary}, ${CartSummaryToggle}, ${StyledCartSummaryRow} {
      display: none;
    }
  }
`

export default StyledCartFooter
